import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProjectConfigService } from './services/project-config.service';
import { register } from 'swiper/element/bundle';
import { TokenInterceptorService } from './services/interceptor.service';
import { AuthService } from './services/auth.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { QueryParamsService } from './services/queryparams.service';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

register();

function initializeApp(projectConfigService: ProjectConfigService, queryParamasService: QueryParamsService, authService: AuthService) {
  return async () => {
    await projectConfigService.loadConfig();
    queryParamasService.initialize();
    await authService.getUserByToken();
  };
}

export const mainAppConfigProviders: ApplicationConfig['providers'] = [
  DecimalPipe,
  DatePipe,
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
  provideZoneChangeDetection({ eventCoalescing: true }),
  {
    provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [ProjectConfigService, QueryParamsService, AuthService],
    multi: true
  },
  provideHttpClient(
    withInterceptorsFromDi()
  ),
  provideAnimations(),
  provideToastr(),
  provideLottieOptions({
    player: () => player,
  }),
  provideAnimationsAsync(),
];
